import { render, staticRenderFns } from "./Books.vue?vue&type=template&id=46be8ea2&scoped=true&"
import script from "./Books.vue?vue&type=script&lang=js&"
export * from "./Books.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46be8ea2",
  null
  
)

export default component.exports